import { all, call, put, takeLatest, select } from 'redux-saga/effects'
import ContactButtonAction, {
  ContactButtonTypes,
  ContactButtonSelectors
} from '../Redux/ContactButtonRedux'

export function* onUpdate(api, action) {
  const cbId = yield select(ContactButtonSelectors.contactButtonId)
  const resp = yield call(api.updateContactButton, cbId, action.params)
  if (resp.ok) {
    yield put(ContactButtonAction.contactButtonUpdateSuccess(resp.data))
    yield put(ContactButtonAction.setContactButton(resp.data))
    action.callback('success')
  } else {
    yield put(
      ContactButtonAction.contactButtonUpdateFailure('something went wrong')
    )
    action.callback('failure')
  }
}

export default function* authSagas(api) {
  yield all([
    takeLatest(ContactButtonTypes.CONTACT_BUTTON_UPDATE_REQUEST, onUpdate, api)
  ])
}
